import {Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {BehaviorSubject, ReplaySubject, Subject} from 'rxjs';
import {ApprovalManagerService} from './approval-manager/approval-manager.service';

@Injectable({
  providedIn: 'root'
})
export class PdfViewerService {

  private compareModeSubject$ = new BehaviorSubject(false);
  private initializedSubject$ = new BehaviorSubject({initialize: false, disableAnnotations: false});
  private approvalManagerService$: ApprovalManagerService;
  private selectedVersionSubject$ = new ReplaySubject<any>(1);
  private compareVersionSubject$ = new ReplaySubject<any>(1);
  private downloadSubject$ = new Subject<any>();
  private downloadAllSubject$ = new Subject<any>();
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  compareModeChanged() {
    return this.compareModeSubject$.asObservable();
  }

  enableCompareMode(turnOn: boolean) {
    this.compareModeSubject$.next(turnOn);
  }

  get approvalManagerService(): ApprovalManagerService {
    return this.approvalManagerService$;
  }

  set approvalManagerService(am: ApprovalManagerService) {
    this.approvalManagerService$ = am;
  }

  selectedVersionChanged() {
    return this.selectedVersionSubject$.asObservable();
  }

  compareVersionChanged() {
    return this.compareVersionSubject$.asObservable();
  }

  setSelectedVersion(version) {
    this.selectedVersionSubject$.next(version);
  }

  setCompareVersion(version) {
    this.compareVersionSubject$.next(version);
  }

  initializedChanged() {
    return this.initializedSubject$.asObservable();
  }

  showViewer(customClass: string = '', disableAnnotations: boolean = false) {
    if (!this.initializedSubject$.getValue()?.initialize) {
      this.initializedSubject$.next({initialize: true, disableAnnotations});
    }
    const viewer = document.getElementById('pdf-viewer');
    this.renderer.removeClass(viewer, 'pdf-viewer-hidden');
    this.renderer.addClass(viewer, customClass);
  }

  hideViewer() {
    const viewer = document.getElementById('pdf-viewer');
    this.renderer.addClass(viewer, 'pdf-viewer-hidden');
    this.enableCompareMode(false);
    this.setSelectedVersion(null);
    this.setCompareVersion(null);
  }

  triggerDownloadWithAnnotations(fileName: string) {
    this.downloadSubject$.next(fileName);
  }

  triggerDownloadAllWithAnnotations(versions) {
    this.downloadAllSubject$.next(versions);
  }

  downloadClicked() {
    return this.downloadSubject$.asObservable();
  }

  getDownloadAllSubject() {
    return this.downloadAllSubject$.asObservable();
  }
}
